export const en = {
    cancel: 'Cancel',
    stop: 'Stop',
    'stop-active-brand-lift-for-campaigns': 'A Brand Lift analysis is being run in campaigns:',
    'stop-active-brand-lift-for-campaigns-helper':
        "Don't stop these campaigns prematurely: the collected data may not be sufficient to make valid conclusions."
};
